import { t } from "@lingui/macro";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Button } from "@whoosh/design-system/src/components/controls";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { ClubStackNavigatorParamList } from "../../../../../navigators/ClubNavigator";
import { useJoinableSpots } from "../../hooks/useJoinableSpots";
import { InviteCardActionButton_Booking$key } from "./__generated__/InviteCardActionButton_Booking.graphql";

export const InviteCardActionButton = ({
  bookingRef,
  onContinuePress,
}: {
  bookingRef: InviteCardActionButton_Booking$key | null;
  onContinuePress: () => void;
}) => {
  const data = useFragment(InviteCardActionButtonFragmentString, bookingRef);
  const { hasJoinableSpots } = useJoinableSpots(data ?? null);
  const navigation =
    useNavigation<NavigationProp<ClubStackNavigatorParamList>>();

  const facilitySlug = data?.startSlot?.agenda?.facility?.slug;

  const handleNavigateToAgenda = () => {
    if (facilitySlug) {
      navigation.navigate("Agenda", {
        facilitySlug,
      });
    }
  };

  return (
    <Box padding={5} backgroundColor="surface-primary">
      {hasJoinableSpots ? (
        <Button
          onPress={onContinuePress}
          accessibilityLabel={t`Continue`}
          testID="invite-card-action-button-continue"
        >{t`Continue`}</Button>
      ) : (
        <Button
          variant={"secondary"}
          onPress={handleNavigateToAgenda}
          accessibilityLabel={t`View Tee Sheet`}
          testID="invite-card-action-button-view-tee-sheet"
        >{t`View Tee Sheet`}</Button>
      )}
    </Box>
  );
};

const InviteCardActionButtonFragmentString = graphql`
  fragment InviteCardActionButton_Booking on Booking {
    ...useJoinableSpots_Booking
    startSlot {
      agenda {
        facility {
          slug
        }
      }
    }
  }
`;
